<template>
  <div class="container">
    <div class="information">
      当前就诊人：{{ defaultPatient }}
      <button @click="selectPatient">切换</button>
    </div>
    <van-tabs v-model="active" @click="checkTabs">
      <van-tab title="未缴费">
        <div class="tab-container">
          <div class="bill-item" v-for="(item, index) in payList" :key="index">
            <div class="bill-cell">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">{{ item.sectionName }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">预约医生：</div>
              <div class="bill-cell-text">{{ item.doctorName }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">就诊时间：</div>
              <div class="bill-cell-text">
                {{ item.visitDate }}
              </div>
            </div>
            <div class="pay-content">
              <div class="pay-content-label">
                未付金额
                <span class="much">￥{{ item.amount }}</span>
              </div>
              <div class="pay-content-text" @click="goBillDetail(item.id)">
                查看详情 <van-icon name="arrow" size="16" color="#999" />
              </div>
            </div>
          </div>
          <van-empty
            v-if="!payList.length"
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />
        </div>
      </van-tab>
      <van-tab title="已缴费">
        <div class="tab-container">
          <div class="bill-item" v-for="(item, index) in payList" :key="index">
            <!-- <div class="bill_p" v-if="item.state != 'N'">已退挂</div> -->
            <div class="bill-cell">
              <div class="bill-cell-label">就诊科室：</div>
              <div class="bill-cell-text">{{ item.DeptName }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">预约医生：</div>
              <div class="bill-cell-text">{{ item.DoctName }}</div>
            </div>
            <div class="bill-cell">
              <div class="bill-cell-label">就诊时间：</div>
              <div class="bill-cell-text">
                {{ item.RegDate }}
              </div>
            </div>
            <div class="pay-content">
              <div class="pay-content-label">
                付款金额
                <span class="much">￥{{ item.RegFee }}</span>
              </div>
              <div class="pay-content-text" @click="goBillDetail(item)">
                查看详情 <van-icon name="arrow" size="16" color="#999" />
              </div>
            </div>
          </div>
          <van-empty
            v-if="!payList.length"
            class="custom-image"
            image="https://img.yzcdn.cn/vant/custom-empty-image.png"
            description="暂无数据"
          />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {
  getDefaultPatient,
  findOrderInfoByPatient,
  getPayOrderList
} from '@/api/api'
export default {
  data() {
    return {
      active: 0,
      defaultPatient: '',
      patientId: '',
      payList: []
    }
  },
  created() {},
  mounted() {
    if (this.$route.query.active) this.active = this.$route.query.active
    if (this.$route.query.patientId) {
      this.defaultPatient = this.$route.query.patientName
      this.patientId = this.$route.query.patientId
      this.getData(this.$route.query.patientId)
    } else {
      this.getList()
    }
  },
  methods: {
    getList() {
      getDefaultPatient().then(res => {
        if (res.data && res.data.length == 1) {
          this.defaultPatient = res.data[0].patientName
          this.patientId = res.data[0].patientId
          this.getData()
        } else {
          this.defaultPatient = '暂无就诊人，请选择'
          this.patientId = ''
        }
      })
    },
    getData() {
      this.payList = []
      if (this.patientId != '') {
        let data = {
          patientId: this.patientId,
          status: this.active + ''
        }
        if (this.active == 1) {
          getPayOrderList({ patientId: this.patientId }).then(res => {
            if (res.code === 200) {
              this.payList = JSON.parse(res.msg).body
            }
            this.payList = this.payList.map(item => {
              item.RegDate = item.RegDate.slice(0, 10).replace(/\//g, '-')
              return item
            })
            // this.payList = res.data.map(item => {
            //   return {
            //     sectionName: item.dept,
            //     doctorName: item.dr,
            //     amount: item.money,
            //     visitDate: item.time,
            //     billQRCode: item.billqrcode,
            //     orderNo: item.trad_NO,
            //     clinicCode: item.caseno,
            //     state: item.state,
            //     flag: item.flag
            //   }
            // })
          })
        } else {
          findOrderInfoByPatient(data).then(res => {
            this.payList = res.data
          })
        }
      }
    },
    goBillDetail(item) {
      if (this.active == 1) {
        this.$router.push({
          name: 'billDetail',
          params: {
            patientName: this.defaultPatient,
            ...item,
            status: this.active,
            patientId: this.patientId
          }
        })
      } else {
        this.$router.push({
          name: 'billDetail',
          query: {
            patientId: this.patientId,
            patientName: this.defaultPatient,
            id: item,
            status: this.active
          }
        })
      }
    },
    selectPatient() {
      this.$router.push({
        name: 'patientList',
        query: {
          select: 'payList'
        }
      })
    },
    checkTabs(name, title) {
      this.getData()
    },
    returnAmount(am) {
      return Number(am) / 100
    }
  }
}
</script>

<style lang="scss" scoped>
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
  padding: 3px 10px;
}

.tab-container {
  height: calc(100vh - 85px);
  background: rgb(242, 248, 253);
  overflow-y: auto;
}

.bill-item {
  width: 100vw;
  padding: 5px 15px;
  background: #fff;
  margin-bottom: 10px;
  position: relative;

  .bill_p {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .bill-cell {
    width: 100%;
    display: flex;
    align-items: center;
    height: 30px;

    &-label {
      width: 100px;
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;
    }

    &-text {
      width: calc(100% - 70px);
      font-size: 18px;
    }
  }

  .pay-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid rgb(234, 234, 234);
    height: 50px;

    &-label {
      color: #666;
      display: flex;
      align-items: center;
      font-size: 18px;

      .much {
        font-size: 18px;
        color: rgb(237, 125, 84);
        margin-left: 10px;
      }
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 18px;
    }
  }
}
</style>
<style lang="css" scope>
.van-tabs__line {
  width: 50%;
  height: 2px;
  background-color: #3478f7;
}
</style>
